/** Port links are external web addresses, never relative application routes. */
export function getPortDocumentUrl(value?: string | null): string | undefined {
    if (!value) return undefined;
    try {
        const url = new URL(value.trim());
        return ["https:", "http:"].includes(url.protocol) && !url.username && !url.password
            ? url.href
            : undefined;
    } catch {
        return undefined;
    }
}
